var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('x-data-table',{attrs:{"caption":"Параметры","headers":_vm.headers,"items":_vm.items,"hide-default-footer":true}})}
var staticRenderFns = []

export { render, staticRenderFns }